import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AuthLoginResponseSuccessDto, UserView } from '../../../_generated';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: emptyProps(),
    'Sign In': props<{ email: string; password: string }>(),
    'Sign In Success': emptyProps(),
    'Sign In Failure': props<{ error: string }>(),
    'Change Password Required': props<{
      response: AuthLoginResponseSuccessDto;
    }>(),
    'Change Password': props<{
      email: string;
      currentPassword: string;
      newPassword: string;
      session: string;
    }>(),

    'Change Password Success': emptyProps(),
    'Change Password Failure': props<{ error: string }>(),
    'Confirm Change Password Required': props<{
      response: AuthLoginResponseSuccessDto;
    }>(),
    'Confirm Change Password': props<{
      email: string;
      confirmationCode: string;
      newPassword: string;
    }>(),
    'Confirm Change Password Success': emptyProps(),
    'Confirm Change Password Failure': props<{ error: string }>(),
    'Authenticate User': emptyProps(),
    'Authenticate User Success': props<{ user: UserView }>(),
    'Authenticate User Failure': props<{ error: string }>(),
    'Start Refresh Tokens Timer': emptyProps(),
    'Refresh Tokens': emptyProps(),
    'Refresh Tokens Success': emptyProps(),
    'Refresh Tokens Failure': props<{ error: string }>(),
    Logout: emptyProps(),
    'Logout Success': emptyProps(),
    'Logout Failure': props<{ error: string }>(),
    'Forgot Password': props<{ email: string }>(),
    'Forgot Password Success': props<{ message: string }>(),
    'Forgot Password Failure': props<{ error: string }>(),
    'Confirm Forgot Password': props<{
      email: string;
      confirmationCode: string;
      newPassword: string;
    }>(),
    'Confirm Forgot Password Success': emptyProps(),
    'Confirm Forgot Password Failure': props<{ error: string }>(),
  },
});
